import { useQuery } from '@tanstack/react-query'

import { fetchUnreadCount } from './api'
import { CONVERSATIONS_UNREAD_KEY } from './keys'

export function useMessagingUnreadCount() {
  return useQuery({
    queryKey: CONVERSATIONS_UNREAD_KEY,
    queryFn: ({ signal }) => fetchUnreadCount(signal),
    staleTime: 30_000
  })
}
